module.exports = __webpack_public_path__ + "img/quality4.fa82f4c7.png";